<template>
  <div class="modal fade delete-client-current-modal" id="DeleteClientModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Deletar cliente</h1>
                  <button type="button" class="btn-close delete-client-current-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formDeleteClient" v-on:submit="deleteClientMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p>Quer realmente deletar o cliente "{{ getCurrentDeleteClient.name }}" ?</p>
                  <p>se precisar deste cliente no futuro, vai precisar criá-lo novamente</p>
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="password_client_delete" class="form-label fw-medium"
                      >Senha do sistema</label
                    >
                    <input
                      type="password"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="password_client_delete"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiDeleteClient" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageDeleteClient">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger delete-client-current-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonDeleteClient" class="btn btn-dark">Deletar cliente</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../../config/axios.js';

export default {
  name: "DeleteClientModal",
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getCurrentDeleteClient'
    ])
  },
  methods: {
    deleteClientMethod(){
      event.preventDefault();

      if(
        document.getElementById("password_client_delete") == undefined ||
        document.getElementById("password_client_delete").value == ""
      ){
        this.alertResponse("Por favor preencha a senha", true);
        return;
      }

      const password_client_delete = document.getElementById("password_client_delete").value;
      const id_delete = this.getCurrentDeleteClient.id;

      const objClientDelete = {
        "id": id_delete,
        "password": password_client_delete
      }

      const buttonDeleteClient = this.$refs.buttonDeleteClient;
      buttonDeleteClient.disabled = true;
      buttonDeleteClient.innerHTML = "Deletando...";
      const alertResponse = this.alertResponse;

        api.axios.post("/api/delete/client", objClientDelete).catch(function(error){
          if(error.response.data != undefined){
            buttonDeleteClient.innerHTML = "Deletar";
          }
          console.log("error", error);
          alertResponse(error.response.data, true);
        }).then(function(response){
          
          if(response != undefined && response.status == 200){
            buttonDeleteClient.innerHTML = "Cliente deletado com sucesso !";
            window.location.reload();
          } else {
            buttonDeleteClient.disabled = false;
            buttonDeleteClient.innerHTML = "Deletar cliente";
            
            document.getElementById("password_client_delete").value = "";
          }
        });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageDeleteClient").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageDeleteClient").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiDeleteClient");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_client_delete");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>
